<template>
  <div class="register">
    <el-dialog
        title="修改密码"
        :visible.sync="show"
        :before-close="close"
        :close-on-click-modal="false"
        center>
      <!-- 登录模式切换 -->
      <el-form :model="params" >
        <el-form-item
            prop="mobile"
            :rules="[{ required: true, message: '请输入手机号', trigger: 'blur' },
                                         {pattern: /^1[0-9]{10,10}$/, message: '手机号格式错误'}]"
        >
          <el-input class="user_name" v-model="params.mobile" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item
            prop="mobileCode"
            :rules="{ required: true, message: '请输入验证码', trigger: 'blur' }"
        >
          <div>
            <el-input class="code" v-model="params.mobileCode" placeholder="请输入验证码"></el-input>
            <el-button class="get_code" @click="getCode" v-if="downcount">获取验证码</el-button>
            <el-button class="get_code" v-else disabled>验证码({{times}}s)</el-button>
          </div>
        </el-form-item>
        <el-form-item

            prop="password"
            :rules="[{ required: true, message: '请输入密码', trigger: 'blur' },
            {pattern: /^(?![a-zA-z]+$)(?!\d+$)(?![!@#$%^&*]+$)[a-zA-Z\d!@#$%^&*]{8,}$/, message: '密码必须包含数字、字母和特殊符号(!@#$%^&*)中至少两种，且长度不少于8位'}]"
        >
          <el-input autocomplete="new-password" type="password" show-password class="password" v-model="params.password" placeholder="请输入新密码"></el-input>
        </el-form-item>
        <el-form-item
            style="margin-top: 25px"
            prop="againPassword"
            :rules="rules.againPassword"
        >
          <el-input autocomplete="new-password" type="password" show-password class="password" v-model="params.againPassword" placeholder="请再次输入密码"></el-input>
        </el-form-item>
        <el-button type="primary" class="login_btn" @click="register">确认修改</el-button>
      </el-form>
      <!-- 文字按钮 -->
      <div class="text_btn">
        <el-button type="text" @click="login">登录</el-button>
      </div>
      <!-- 第三方登录 -->
<!--      <div class="other_login">-->
<!--        <div class="qq_login"></div>-->
<!--        <div class="wx_login"></div>-->
<!--      </div>-->
    </el-dialog>
    <!-- 验证码对话框 -->
    <yzmAlert :yzmObj="yzmObj" @setDwoncountSwitch="downcoutStart"></yzmAlert>
  </div>
</template>

<script>
  import yzmAlert from "@/components/yzm_alert/yzm_alert.vue"
  export default {
    components:{
      yzmAlert
    },
    props:{
      show: false
    },
    data(){
      let validatePass = (rule, value, callback) => {
        if (value === "" || value === null) {
          callback(new Error("请再次输入新密码"));
        } else if (value !== this.params.password) {
          callback(new Error("两次输入密码不一致!"));
        } else {
          callback();
        }
      };
      return{
        activeName: '2',
        params:{
          mobile: '',
          password: '',
          mobileCode: '',
          againPassword: ''
        },
        yzmObj:{
          dialogVisible: false,
          mobile: '',
          type: 'MobileCodeTypeChangePassword'
        },
        rules: {
          password: [
            { required: true, message: '请输入密码', trigger: ['blur', 'change'] },
            {pattern: /^(?![a-zA-z]+$)(?!\d+$)(?![!@#$%^&*]+$)[a-zA-Z\d!@#$%^&*]{8,}$/, message: '密码必须包含数字、字母和特殊符号(!@#$%^&*)中至少两种，且长度不少于8位'}
          ],
          againPassword: [
            { required: true, validator: validatePass, trigger: ['blur', 'change'] }
          ]
        },
        downcount: true, //倒计时切换开关
        times: 60, //倒计时时间
        timer: null, //定时器
      }
    },
    created(){

    },
    methods:{
      /** 点击打开登录对话框*/
      login(){
        this.close();
        this.$store.dispatch('setIsLoginDialog', true)
      },
      // 发送验证码切换倒计时
      downcoutStart(data) {
        if (data) {
          this.downcount = false;
          clearInterval(this.timer);
          this.times = 60;
          this.timer = setInterval(() => {
            this.times--;
            if (this.times === 0) {
              clearInterval(this.timer);
              this.timer = false;
              this.downcount = true;
            }
          }, 1000);
        }
      },
      /** 点击获取验证码*/
      getCode(){
        if (this.downcount) {
          if (!this.params.mobile || !/^1[0-9]{10,10}$/.test(this.params.mobile)) {
            this.$message.info('手机号格式有误');
            return;
          }
          this.yzmObj.mobile = this.params.mobile;
          this.yzmObj.dialogVisible = true;
        }else{
          this.$message.info("请不要重复点击");
        }
      },
      /** 验证表单*/
      submit(form){
        this.$refs[form].validate(valid => {
          if (valid) {
            form==='code_form' ?
                this.loginCode() : this.login();
          } else {
            this.$message.info("请检测必填项!");
            return false;
          }
        });
      },
      /** 注册*/
      async register(){
        let params = {
          mobile: this.params.mobile,
          mobileCode: this.params.mobileCode,
          password: this.common.encryptRSA(this.params.password)
        }
        this.api.modifyPassword(params).then(res=>{
          if(res.error['err_code'] !== 0) return;
          if (res.error.err_code === 0) {
            let html = `<div>您的密码已修改成功，请前往登录</div>`
            this.$alert(html, '密码修改成功', {
              type: 'success',
              dangerouslyUseHTMLString: true,
              callback: action => {
                if(action === 'cancel') return;
                this.close();
                this.$store.dispatch('setIsLoginDialog', true)
              }
            });
          }
        })
      },
      close(){
        Object.assign(this.$data, this.$options.data())
        this.$store.dispatch('setIsForgetPasswordVisible', false)
      }
    }
  }
</script>

<style lang="scss">
.register{
  //对话框样式
  .el-dialog{
    width: 400px;overflow: hidden;
  }
  .el-dialog__header{
    padding: 0;
    height: 60px;
    background-color: #F5F6FA;
    .el-dialog__title{
      line-height: 60px;
      font-size: 20px;
      color: $font-black;
    }
  }
  .el-dialog__body{
    box-sizing: border-box;
    padding: 30px 50px 30px 50px;
  }

  //tab切换
  .el-tabs .el-tabs__header{
    .el-tabs__active-bar{
      display: none;
    }
    .el-tabs__nav-wrap:after{
      display: none;
    }
    .el-tabs__nav-scroll .el-tabs__nav{
      width: 100%;
      display: flex;
      justify-content: space-evenly;
    }
    .el-tabs__item{
      color: $font-gary;
      font-size: 14px;
    }
    .el-tabs__item.is-active{
      color: $font-black;
    }
  }

  //表单
  .el-form{

    .user_name,.password{
      width: 300px;
      height: 36px;
    }
    .code{
      width: 194px;
      height: 36px;
      margin-right: 10px;
    }
    .get_code{
      width: 96px;
    }
    .login_btn{
      width: 300px;
      height: 40px;
    }
  }

  //文字按钮
  .text_btn{
   text-align: center;
    margin-top: 10px;
    color: #AEB4C8;
    font-size: 12px;
    .el-button{
      color: $font-blue;
    }
  }

  //第三方登录
  .other_login{
    display: flex;
    justify-content: space-around;
    margin-top: 10px;

    div{
      width: 40px;
      height: 40px;
      background-color: #999;
    }
  }
}
</style>
